<!--

  TODO: To parse XLS use this library - https://sheetjs.com/

-->

<template>
  <b-modal
    ref="importModal"
    size="md"
    :static="true"
    centered
    hide-header-close
    @hidden="close" >

    <!-- HEADER -->
    <template #modal-title>
      <template v-if="step === 1">
        Import contacts
      </template>

      <template v-if="step === 2">
        <div
          class="back-btn flex flex-align-center"
          @click="previousStep">
          <SBIcon
            :icon="SBIconList.DOWN_ARROW"
            :color="SBColors.greyPrimary"
            :size="11" />
          <p>Customize your import</p>
        </div>
      </template>
    </template>

    <!-- Default import screen -->
    <div v-show="step === 1" class="select-file">
      <div class="info">
        <h3>Preparing your CSV import file</h3>
        <ul>
          <li><span>Supported headings: <i>name, phone, tags{{ customFieldsNames ? `, ${customFieldsNames}` : '' }}</i>.</span></li>
          <li><span>You can import up to {{ contactImportLimits.maxNumberOfContacts | bigDigits }} contacts per session.</span></li>
        </ul>

        <span class="links">
          <span
            class="flex-align-center show-hand"
            @click="downloadExample">
            <SBIcon
              :icon="SBIconList.DOC_NEW"
              :color="SBColors.bluePrimary"
              :size="14" />
            <p>Download CSV template</p>
          </span>
          <!-- <a THIS IS HIDDEN FOR NOW UNTILL WE CREATE THE DOCS FOR THIS
            href="https://developer.ainumber.com"
            target="_blank">
            <span class="flex flex-align-center">
              <SBIcon
                :icon="SBIconList.INFO_INVERSE"
                :color="SBColors.bluePrimary"
                :size="14" />
              <p>Learn more</p>
            </span>
          </a> -->
        </span>
      </div>

      <DropZone
        ref="dropZone"
        v-model="files"
        :extensions="['csv']"
        placeholder="Select or drop CSV file here"
        unsupported-file-type-message="Wrong file format, please select .CSV file type."
        @dropped-in="fileDropped" />
      <p
        v-if="results && results.data.length > contactImportLimits.maxNumberOfContacts"
        class="error flex flex-align-center" >
        <SBIcon
          :icon="SBIconList.ERROR"
          :color="SBColors.redPrimary"
          :size="12" />
        <span>You can't import more than {{ contactImportLimits.maxNumberOfContacts | bigDigits }} contacts at a time.</span>
      </p>

      <p
        v-if="hasHeader && (!results.data || !results.data.length)"
        class="error flex flex-align-center" >
        <SBIcon
          :icon="SBIconList.ERROR"
          :color="SBColors.redPrimary"
          :size="12" />
        <span>There are no contacts in the selected file.</span>
      </p>
    </div>

    <template v-if="step === 2">
      <p class="description">Select the correct contact field for each column you'd like to import. A contact field is a data field for storing contact information.</p>
      <div class="import-grid">
        <!-- Column names -->
        <span class="header col-span_1-2">CSV column</span>
        <!-- <span></span> -->
        <span class="header">Contact field</span>
        <template
          v-for="(field, index) in results.meta.fields.filter(f => f)" >
          <div
            :key="index"
            class="file-fields flex flex-align-center">
            <SBIcon
              :icon="SBIconList.TABLE"
              color="#00bfa5"
              :size="14" />
            <p class="ellipsis">{{ field }}</p>
          </div>
          <div
            :key="`arrow-${index}`"
            class="arrow">
            <SBIcon
              :icon="SBIconList.ARROW_DOWN"
              :color="SBColors.blackPrimary"
              :size="12"
              class="rotate-270" />
          </div>
          <div
            :key="`import-${index}`"
            class="import-fields">
            <multiselect
              :id="index"
              v-model="importFields[field]"
              class="flex-options hide-tags no-selected-background"
              :options="availableFields"
              :multiple="false"
              :show-labels="false"
              :show-no-results="false"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="false"
              group-values="options"
              group-label="name"
              :group-select="false"
              placeholder="Select"
              track-by="id"
              label="name"
              :allow-empty="true"
              :searchable="true"
              @select="multiselectSelect"
              @remove="multiselectRemove" >
              <template
                slot="singleLabel"
                slot-scope="props">
                <div class="flex flex-align-center">
                  <SBIcon
                    :icon="props.option.icon"
                    :color="SBColors.blackPrimary"
                    :size="12"/>
                  <span
                    class="multiselect__single ellipsis ml-2" >{{ props.option.name }}</span>
                </div>
              </template>
              <template
                slot="option"
                slot-scope="props">
                <div
                  v-if="props.option.$isLabel"
                  class="flex flex-align-center multiselect__single-wrapper"
                  :class="{hide: props.option.$isLabel && props.option.$groupLabel === 'hide'}" >
                  <span
                    class="multiselect__single ellipsis" >{{ props.option.$groupLabel }}</span>
                </div>
                <div
                  v-else
                  class="flex flex-align-center multiselect__single-wrapper" >
                  <SBIcon
                    :icon="props.option.icon"
                    :color="SBColors.blackPrimary"
                    :size="14"/>
                  <span
                    class="multiselect__single ellipsis" >{{ props.option.name }}</span>
                </div>
              </template>
            </multiselect>

            
          </div>
        </template>
      </div>
      <div
        v-if="errorMessage"
        class="error flex center-all" >
        <SBIcon
          :icon="SBIconList.ERROR"
          :color="SBColors.redPrimary"
          :size="14"/>
        <p>{{ errorMessage }}</p>
      </div>
    </template>

    <!-- FOOTER -->
    <template slot="modal-footer">
      <b-button
        :disabled="processing"
        @click="hide" >
        <span>Cancel</span>
      </b-button>
      <SB2Button
        v-if="step === 1"
        variant="primary"
        :disabled="
          !results ||
            (hasHeader && (!results.data || !results.data.length)) ||
            (results && results.data.length > contactImportLimits.maxNumberOfContacts)
        "
        @click="nextStep" >
        Next
      </SB2Button>
      <SB2Button
        v-else-if="step === 2"
        variant="primary"
        :disabled="processing"
        :loading="processing"
        @click="validateAndSend" >
        Import {{ (hasHeader ? results.data.length : results.data.length + 1) | bigDigits }} contact{{ (hasHeader ? results.data.length : results.data.length + 1) === 1 ? '' : 's' }}
      </SB2Button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Papa from 'papaparse';
import Multiselect from 'vue-multiselect';

import DropZone from '../../../common/DropZone';
import SB2Button from '../../../common/SB2Button';
import SBIcon from '../../../common/Icon';
import SBIconList from '../../../../helpers/lists/sb-icon-list';
import SBColors from '../../../../helpers/lists/colors';
import JuneMixin from '@/mixins/June';

export default {
  name: 'ImportModal',
  components: {
    DropZone,
    SB2Button,
    SBIcon,
    Multiselect,
  },
  mixins: [
    JuneMixin,
  ],
  props: {},
  data() {
    return {
      files: [],
      formData: new FormData(),
      errorMessage: null,
      step: 1,
      processing: false,
      results: null,
      importFields: {},
      defaultFields: [
        {
          name: 'hide',
          options: [
            {
              id: 0,
              name: 'Do not import',
              icon: SBIconList.BLOCK,
            },
          ],
        },
        {
          name: 'Contact info',
          options: [
            {
              id: 'phone',
              name: 'Phone number',
              icon: SBIconList.PHONE,
            },
            {
              id: 'name',
              name: 'Name',
              icon: SBIconList.USER_SQUARE,
            },
            {
              id: 'tags',
              name: 'Tags',
              icon: SBIconList.TAG,
            },
          ],
        },
      ],
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      customFieldList: 'contact/customFieldList',
      currentOrganisation: 'organisation/currentOrganisation',
      contactImportLimits: 'system/contactImportLimits',
    }),
    // To determine if the input file has headers we are checking the columns searching for the one having number as value and then we treat the file as no header file. Otherwise the file has headers.
    // Alternative is to ask the user if a file has headers but we'd like to avoid that confusion.
    hasHeader() {
      return this.results && !this.results.meta.fields.some(field => /^\+?\s?[\d\s]+$/.test(field.trim()));
    },
    availableFields() {
      const customFields = [{
        name: 'Contact fields',
        options: this.customFieldList[this.currentOrganisation.id]
          .filter(cf => cf.type !== 'list')
          .map(cf => ({
            id: cf.id,
            name: cf.name,
            icon: SBIconList[`CF_${cf.type.toUpperCase()}`],
          }))
          .sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1)),
      }];
      return [...this.defaultFields, ...customFields];
    },
    customFieldsNames() {
      return this.customFieldList[this.currentOrganisation.id] ? this.customFieldList[this.currentOrganisation.id]
        .filter(cf => cf.type !== 'list')
        .map(cf => cf.name)
        .sort((a, b) => (a.toLowerCase() < b.toLowerCase() ? -1 : 1)).join(', ') : null;
    },
  },
  watch: {},
  methods: {
    ...mapActions({
      importContacts: 'organisation/importContacts',
    }),
    show() {
      this.$refs.importModal.show();
    },
    hide() {
      this.$refs.importModal.hide();
    },
    fileDropped(file) {
      if (file && file[0]) {
        this.formData.set('file', file[0]);

        Papa.parse(file[0], {
          quoteChar: '"',
          header: true,
          // worker: false,
          complete: this.papaComplete,
          error: this.papaError,
          skipEmptyLines: true,
        });
      } else {
        this.formData.delete('file');
        this.results = null;
      }
    },
    papaComplete(results, file) {
      // console.log("Parsing complete:", results, file);
      this.results = results;
    },
    papaError(error, file) {
      // console.log("Parsing error:", error, file);
    },
    clearFile() {
      this.formData.delete('file');
      this.files = [];
      if (this.$refs.dropZone) {
        this.$refs.dropZone.clearFiles();
      }
      this.step = 1;
    },
    close() {
      this.$emit('close');
      this.clearFile();
      this.results = null;
      this.errorMessage = null;
      this.importFields = {};
      this.processing = false;
    },
    downloadExample() {
      let csvReport = 'data:text/csv;charset=utf-8,';

      // name, phone, tags, organisation custom fields
      csvReport += `"name","phone","tags",${this.customFieldList[this.currentOrganisation.id].map(cf => `"${cf.name}"`)}\r\n`;

      let descriptionRow = '"Contact full name","Add phone number in international format","Add one or multiple tags. Use commas to separate tags.",';
      let exampleRow = '"John Doe","+987 654 321 000","Tag 1, Tag 2, Tag 3",';

      this.customFieldList[this.currentOrganisation.id].forEach((cf) => {
        switch (cf.type) {
          case 'date':
            descriptionRow += '"This is a date type contact field. Add any standard date format.",';
            exampleRow += '"1-12-2024",';
            break;
          case 'text':
            descriptionRow += '"This is a text type contact field. Add any type of text.",';
            exampleRow += '"Lorem ipsum dolor sit amet, consectetur adipiscing elit...",';
            break;
          case 'list':
            descriptionRow += '"Lists can\'t be imported",';
            exampleRow += '"Please skip list data import",';
            break;
          case 'number':
            descriptionRow += '"This is a number type contact field. Add numbers in decimal or non decimal format.",';
            exampleRow += '"1234.56789",';
            break;
          case 'boolean':
            descriptionRow += '"This is a yes/no type contact field. Add TRUE or FALSE, YES or NO, and 0 or 1 as valid values.",';
            exampleRow += '"TRUE",';
            break;
          case 'email':
            descriptionRow += '"This is an email type contact field. Add any valid email.",';
            exampleRow += '"john.doe@example.com",';
            break;
          default:
            break;
        }
      });

      csvReport += `${descriptionRow.replace(/,$/, '')}\r\n`;
      csvReport += `${exampleRow.replace(/,$/, '')}\r\n`;

      const encodedUri = encodeURI(csvReport);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      const filename = `example-contacts-${this.$moment().format('YYYY-MM-DD-HHmm')}.csv`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);

      link.click();
    },
    nextStep() {
      if (this.step === 1) {
        this.prematchFields();
      }
      this.step++;
    },
    previousStep() {
      this.step--;
    },
    prematchFields() {
      const matches = {};
      const baseFields = this.availableFields[1].options.map(o => o.id.toLowerCase());
      const customFields = this.availableFields[2].options.map(o => ({ name: o.name.toLowerCase(), id: o.id }));
      this.results.meta.fields.forEach((field) => {
        const baseMatchIndex = baseFields.findIndex(bf => field.toLowerCase().indexOf(bf.toLowerCase()) >= 0);
        if (baseMatchIndex >= 0) {
          matches[field] = baseFields[baseMatchIndex];
          baseFields.splice(baseMatchIndex, 1);
        } else {
          const customFieldsMatchIndex = customFields.findIndex(cf => field.toLowerCase().indexOf(cf.name.toLowerCase()) >= 0);
          if (customFieldsMatchIndex >= 0) {
            matches[field] = customFields[customFieldsMatchIndex].id;
            customFields.splice(customFieldsMatchIndex, 1);
          }
        }
      });

      // Find the right option and preset it to importFields model
      const options = [...this.availableFields[1].options, ...this.availableFields[2].options];
      Object.keys(matches).forEach((matchKey) => {
        const option = options.find(o => o.id.toLowerCase() === matches[matchKey].toLowerCase());
        if (option) {
          this.importFields[matchKey] = option;
        }
      });
      this.importFields = { ...this.importFields };
    },
    validateAndSend() {
      this.processing = true;
      let mappings = {};
      let valid = false;
      Object.keys(this.importFields).forEach((key) => {
        const numberedKey = `c${this.results.meta.fields.findIndex(k => k === key)}`;
        if (this.importFields[key].id) {
          mappings[numberedKey] = this.importFields[key].id;
          if (mappings[numberedKey] === 'phone') {
            valid = true;
          }
        }
      });
      if (!this.hasHeader) {
        mappings = this.convertToIndexMappings(mappings);
      } else {
        // New colmn names will be sent to backend to prevent any issue with duplicate column names
        // These column names are also used for mappings above
        this.formData.set('column_names', JSON.stringify(this.results.meta.fields.map((f, i) => `c${i}`)));
      }
      if (!valid) {
        this.errorMessage = 'Phone number field must be specified.';
        this.processing = false;
      } else {
        // Start import
        this.errorMessage = null;
        this.formData.set('field_mapping', JSON.stringify(mappings));
        this.importContacts(this.formData)
          .then((data) => {
            if (data.status === 200) {
              this.juneTrack('Contact import started', {
                fileName: this.files[0].name,
                numberOfContacts: this.hasHeader ? this.results.data.length : this.results.data.length + 1,
              });
              this.hide();
            }
          })
          .catch((error) => {
            this.processing = false;
            this.errorMessage = error.message;
          });
      }
    },
    convertToIndexMappings(mapping) {
      const newMapping = {};
      Object.keys(mapping).forEach((key) => {
        newMapping[this.results.meta.fields.findIndex(k => k === key)] = mapping[key];
      });

      return newMapping;
    },
    multiselectSelect(selectedOption, index) {
      this.$nextTick(() => {
        if (selectedOption.id) {
          Object.keys(this.importFields).forEach((key) => {
            if (this.results.meta.fields[index] !== key && this.importFields[key].id === selectedOption.id) {
              delete this.importFields[key];
            }
          });
        }
      });
    },
    multiselectRemove(removedOption, id) {
      // console.log(id, removedOption);
    },
  },
};
</script>

<style lang="scss" scoped>
// recheck
.importing .progress,
.select-file {
  .file-uploads {
    margin: 10px 0;
  }

  .error {
    margin-top: 10px;
  }
}

.file-name {
  margin-top: 20px;
}

.strong {
  font-weight: 500;
}

.stats h1 {
  font-size: 20px!important;
}

.modal-footer button {
  // margin: 10px 10px 10px 0!important;
}

a:hover, a:visited {
  text-decoration: none;
}

.alert {
  text-align: left;
}






.modal-header {
  .modal-title {
    .back-btn {
      max-width: fit-content;
      cursor: pointer;
      padding: 7px 11px 7px 8px;
      margin: -7px 0 -7px -11px !important;
      border-radius: 5px;

      .sb-icon {
        transform: rotate(90deg);
        margin-right: 8px;
      }

      p {
        font-size: 16px;
        font-weight: 500;
        color: $blackPrimary;
        margin-top: 0;
      }

      &:hover {
        background: #edf0f2;

        .sb-icon .mask {
          background-color: $blackPrimary !important;
        }
      }
    }

    p {
      margin: 7px 0 0 0;
      font-size: 14px;
      font-weight: normal;
      color: #54626c;
    }
  }
}

::v-deep .modal-body {
  // max-height: 300px;
  // overflow-y: auto;
  background-color: $white !important;
}

.description {
  line-height: initial;
  color: #54626c;
}

.info {
  margin: 0 0 20px 0;
  padding: 20px 15px;
  border-radius: 5px;
  border: solid 1px #e1e5eb;
  background-color: #f8fbff;

  h3 {
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    color: $blackPrimary;
    margin-bottom: 17px;
  }

  ul {
    list-style: none;
    margin-bottom: 20px;

    li {
      font-size: 14px;
      font-weight: normal;
      line-height: 1.2;
      text-align: left;
      color: $blackPrimary;
      margin-bottom: 15px;
      display: flex;

      &::before {
        content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
        color: $blackUltralight; /* Change the color */
        font-weight: bold; /* If you want it to be bold */
        display: inline-block; /* Needed to add space between the bullet and the text */
        width: 16px; /* Also needed for space (tweak if needed) */
        flex-shrink: 0;
      }
    }
  }

  .links {
    & > span, & > a {
      display: inline-flex;
      margin-right: 19px;
    }

    * {
      display: inline;
      color: $bluePrimary;
      font-size: 14px;
      font-weight: 500;
    }

    .sb-icon {
      margin-right: 8px;
    }

    p {
      
    }
  }
}

::v-deep .drop-zone .error {
  font-size: 14px;
  font-weight: normal;
  padding-left: 0 !important;
}

.error {
  margin-top: 20px;
  padding: 0;
  color: #ff5b61;
  font-size: 14px;
  display: flex;
  align-items: center;

  .info-label {
      margin-left: 5px;
  }

  .sb-icon {
    margin-right: 6px;
  }
}

.import-grid {
  display: grid;
  grid-template-columns: calc(50% - 25px) 30px calc(50% - 25px); //calc(50% - 25px) 50px calc(50% - 25px);
  gap: 10px;
  justify-content: space-between;
  margin-top: 24px;

  & > * {
    // background: red;
  }

  .header {
    font-size: 14px;
    font-weight: 500;
    padding-bottom: 7px;
  }

  .col-span_1-2 {
    grid-column: 1 / span 2;
  }

  .file-fields {
    margin: 0;
    padding: 9px 14px;
    border-radius: 5px;
    background-color: #edf0f2;

    p {
      padding-left: 7px;
    }
  }

  .arrow {
    justify-self: center;
    align-self: center;
  }

  .import-fields {

  }

  ::v-deep .multiselect.flex-options .multiselect__content-wrapper .multiselect__content .multiselect__option {
    padding: 0 !important;

    .multiselect__single-wrapper {
      padding: 8px 12px !important;
      &.hide {
        display: none !important;
      }
    }

    &.multiselect__option--highlight {
      // background-color: red !important;
    }

    .sb-icon {
      margin: 0;
      visibility: visible !important;
    }
    .multiselect__single {
      padding-left: 7px;
      margin: 0px;
      background: none !important;
    }

    &.multiselect__option--group {
      background: none !important;

      & > :not(.disabled) {
        .multiselect__single {
          font-size: 12px !important;
          font-weight: 500 !important;
          color: $greyPrimary !important;
          padding-left: 0 !important;
          padding-top: 7px !important;
        }
      }

      & > .disabled {
        .sb-icon .icon.mask {
          background-color: $greyPrimary !important;
        }
        .multiselect__single {
          color: $greyPrimary !important;
        }
      }
    }
  }
}
</style>
